import classNames from 'classnames';
export default function CheckCircleIcon({ size = 24, color, className }) {
    return (<svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={classNames('fill-current', className, color)}>
      <path fill="currentColor" fillRule="evenodd" d="M9 3a6 6 0 1 0 0 12A6 6 0 0 0 9 3ZM1.5 9a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0Zm10.28-2.03a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06 0L5.845 9.155a.75.75 0 0 1 1.06-1.06L8.25 9.439l2.47-2.47a.75.75 0 0 1 1.06 0Z" clipRule="evenodd"/>
    </svg>);
}
